const getTokensFromPath = (path) => {
  var tokens = {
    accessToken: null,
    idToken: null,
    tokenType: null,
    expiresIn: null
  }
  console.log('checking path length')
  if (path.length === 0) {
    return tokens
  }

  console.log('strip leading chars')
  // Strip leading /
  if (path.startsWith('/')) {
    path = path.substring(1)
  }

  console.log('parsing hash params')
  let hashParams = path.split('&')
  for (let i in hashParams) {
    let param = hashParams[i]
    let keyValue = param.split('=')
    const keyValueMap = {
      id_token: 'idToken',
      access_token: 'accessToken',
      token_type: 'tokenType',
      expires_in: 'tokensExpireIn'
    }
    const tokenKey = keyValueMap[keyValue[0]]

    tokens[tokenKey] = keyValue[1]
    console.log(tokens)
    console.log(tokenKey)
  }
  return tokens
}

const storeTokensInSession = (tokens) => {
  if (tokens.accessToken !== null 
      && tokens.idToken !== null 
      && tokens.tokenType !== null) {
    sessionStorage.setItem('accessToken', tokens.accessToken)
    sessionStorage.setItem('idToken', tokens.idToken)
    sessionStorage.setItem('tokenType', tokens.tokenType)
    // Have a second look at this:
    // https://stackoverflow.com/questions/15171711/expiry-of-sessionstorage#:~:text=It%20doesn't%20expire%20automatically,(in%20some%20browsers%2010mb).
    // TODO: do something with `expires_in`
  }
}

const getIdToken = () => {
  let jwt = sessionStorage.getItem('idToken')
  return jwt
}

const getLoggedInUserEmail = () => {
  let jwt = getIdToken()
  if (jwt === null) {
    // No id token is available; user isn't
    // logged in.
    return ''
  }
  // Check for null
  let payload = jwt.split('.')[1]
  let payloadObj = JSON.parse(atob(payload))
  return payloadObj.email
}

const clearTokens = () => {
  sessionStorage.removeItem('idToken')
  sessionStorage.removeItem('accessToken')
  sessionStorage.removeItem('tokenType')
  sessionStorage.removeItem('tokensExpireIn')
}

export {
  clearTokens,
  getTokensFromPath,
  storeTokensInSession,
  getIdToken,
  getLoggedInUserEmail
}


//////////////////
// WEBPACK FOOTER
// ./src/TokenUtils.ts
// module id = null
// module chunks = 